<template>
<div>
  <div class="search-results-container pb-4 pt-4 mr-md-3">
    <alert-message v-if="!isSearchLoading && showErrorMessage && noSupplierCentralResultsExist" class="large-panel"></alert-message>
    <template v-if="showSearchResults">
      <div class="search-result-card pt-4">

        <div v-for="(searchResult, key) in filteredHomePageResults" :key="key">
          <div class="search-results-panel m-0">
            <div v-if="searchResult.actionType === 'LINK'">
                <show-external-link
                    :hrefUrl="searchResult.route"
                    isSearchTitle="true"
                    @onClearSearchTerm="onSearchResultClicked"
                    >
                  <span class="solution-link-title">{{ searchResult.name }}</span>
                </show-external-link>
            </div>
            <div v-else-if="searchResult.actionType === 'MODAL'">
              <div
                  class="search-result-title solution-link"
                  @click="navigateTo(searchResult.route)"
                  >{{ searchResult.name }}</div>
            </div>
            <div class="row content-card">
              <div class="col-12">
                <span class="span-tag">ANSWERS</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-for="(searchResult, key) in filteredPurchaseOrdersSearchResults" :key="key">
        <purchase-order-result-card :result="searchResult"  @onSearchResultClicked="onSearchResultClicked" />
      </div>

      <div v-for="(searchResult, key) in filteredInvoiceSearchResults" :key="key">
        <InvoiceResultCard :result="searchResult"  @onSearchResultClicked="onSearchResultClicked" />
      </div>

      <!-- We need to keep below code as we need to enable it eventually -->
<!--      If its supplier then Engage with Supplier, if its Product then Get it if website exists-->
<!--      <div v-for="(searchResult, key) in filteredSuppliers" :key="key">-->
<!--        <div class="search-results-panel m-0">-->
<!--          <div class="row no-gutters justify-content-start">-->
<!--            <div class="search-result-title" @click="engageWithSupplier(searchResult.id)">{{ searchResult.name }}</div>-->
<!--          </div>-->
<!--          <div class="search-result-desc" v-if="searchResult.supplierId">Supplier ID: {{searchResult.supplierId}}</div>-->
<!--          <div class="row content-card">-->
<!--            <div class="col-12">-->
<!--              <span class="span-tag">SUPPLIERS</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <div v-for="(searchResult, key) in filteredProducts" :key="key">
        <div class="search-results-panel m-0">
          <div class="row no-gutters justify-content-start">
                <a v-if="searchResult.engagementUrl" :href="searchResult.engagementUrl" target="_blank" class="search-result-title">{{searchResult.nextSteps}}</a>
                <span v-else class="search-result-title" @click="engageWithSupplier(searchResult.vendorId)">{{searchResult.nextSteps}}</span>
          </div>
          <div class="search-result-desc">{{searchResult.name}}</div>
          <div class="row content-card">
            <div class="col-12">
              <span class="span-tag">SOFTWARE</span>
            </div>
          </div>
        </div>
      </div>

      <div v-for="(searchResult, key) in filteredCompletedCases" :key="key">
        <div class="search-results-panel m-0">
          <div class="row no-gutters justify-content-start">
            <div class="col-12">
              <span class="solution-link-title"
                    @click="launchAgentStatusModal(searchResult.caseNumber)">
                {{ searchResult.caseNumber }}
              </span>
              <div class="col-12 px-0">
                <span class="view-status" @click="launchAgentStatusModal(searchResult.caseNumber)">View status</span>
              </div>
            </div>
          </div>
          <div class="row content-card">
            <div class="col-12">
              <span class="span-tag">COMPLETED CASES</span>
            </div>
          </div>
        </div>
      </div>

      <div v-for="(searchResult, key) in filteredPendingCases" :key="key">
        <div class="search-results-panel m-0">
          <div class="row no-gutters justify-content-start">
            <div class="col-12">
              <span class="solution-link-title"
                    @click="launchAgentStatusModal(searchResult.caseNumber)">
                {{ searchResult.caseNumber }}
              </span>
            </div>
            <div class="col-12 px-0">
              <span class="view-status" @click="launchAgentStatusModal(searchResult.caseNumber)">View status</span>
            </div>
          </div>
          <div class="row content-card">
            <div class="col-12">
              <span class="span-tag">PENDING CASES</span>
            </div>
          </div>
        </div>
      </div>

      <div v-for="(searchResult, key) in filteredReturnedCases" :key="key">
        <div class="search-results-panel m-0">
          <div class="row no-gutters justify-content-start">
            <div class="col-12">
                <span class="solution-link-title"
                    @click="launchAgentStatusModal(searchResult.caseNumber)">
                {{ searchResult.caseNumber }}
              </span>
            </div>
            <div class="col-12">
              <span @click="editReturnedRequest(searchResult.id)" class="edit-case-link">Edit case</span>
            </div>
          </div>
          <div class="row content-card">
            <div class="col-12">
              <span class="span-tag">RETURNED CASES</span>
            </div>
          </div>
        </div>
      </div>

      <div class="search-result-card">
        <div v-for="(searchResult, key) in searchResults" :key="key">
          <div class="search-results-panel m-0">
            <a
                class="search-result-title"
                @click="redirectToSolutionsModal(searchResult)"
            >{{ searchResult.name |  ehTruncateHTML(10)}}<font-awesome-icon
                class="ml-1"
                icon="external-link-alt"
            /></a>
            <div class="search-result-desc">
              <div v-if="searchResult.description" >{{searchResult.description |  ehTruncateHTML(20)}}</div>
              <div v-else>{{searchResult.name |  ehTruncateHTML(20)}}</div>
            </div>
            <div class="row content-card" v-if="searchResult.type">
              <div class="col-12">
                <span class="span-tag">{{searchResult.type}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <div class="pt-4" v-if="!showErrorMessage">
      <div v-if="showSearchResults && noResults" class="no-match-card">
        <h4>Sorry, no records were found to match your keywords.</h4>
      </div>
      <div v-if="!isSearchStringValid" class="no-match-card">
        <h4>Please type keywords to search.</h4>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import ShowExternalLink from "@/components/ShowExternalLink";
import filters from "@/filters/filter";
import supplierRequestMixin from "@/mixins/supplierRequestMixin";
import CategoryMixin from "../mixins/CategoryMixin";
import api from "@/api"
import AlertMessage from "./AlertMessage";
import CONSTANTS from "@/store/constants";
import debounce from "lodash/debounce";
import _includes from "lodash/includes";
import InvoiceResultCard from "@/components/InvoiceResultCard";
import PurchaseOrderResultCard from "@/components/PurchaseOrderResultCard";
import InvoicesPOFiltersMixin from "../mixins/InvoicesPOFiltersMixin";

export default {
  name: "SearchResults",
  components: {ShowExternalLink, AlertMessage, PurchaseOrderResultCard,InvoiceResultCard},
  props: ["searchTerm"],
  filters,
  mixins: [supplierRequestMixin, CategoryMixin,InvoicesPOFiltersMixin],
  data() {
    return {
      searchResults: [],
      showErrorMessage: false
    };
  },
  watch: {
    searchTerm(newValue) {
      if(newValue.trim().length>2) {
        this.setShowSearchSpinner(true);
        this.searchDebounce(this);
      }
    },
  },
  async created() {
    if(this.searchTerm.trim().length>2) {
      this.setShowSearchSpinner(true);
      this.searchDebounce(this);
    }
  },
  computed: {
    ...mapGetters([
      "currentAppData",
      "allCategories",
      "currentAlias",
      "suppliers",
      "products",
      "onBoardingPendingRequests",
      "onBoardingCompletedRequests",
      "onBoardingReturnedRequests",
      "showSearchSpinner",
      "formattedInvoices",
      "purchaseOrdersFormattedList",
      "decisionBranches"
    ]),
    isSearchLoading() {
      return this.showSearchSpinner
    },
    showSearchResults() {
      return this.isSearchStringValid && !this.showSearchSpinner
    },
    isSearchStringValid() {
      return this.searchTerm.length>2
    },
    noResults() {
      return (
        this.searchResults.length === 0
        && this.noSupplierCentralResultsExist
      )
    },
    noSupplierCentralResultsExist() {
      return (
        this.filteredHomePageResults.length === 0
        && this.filteredProducts.length === 0
        && this.filteredSuppliers.length === 0
        && this.filteredPendingCases.length === 0
        && this.filteredCompletedCases.length === 0
        && this.filteredReturnedCases.length === 0
        && this.filteredInvoiceSearchResults.length === 0
        && this.filteredPurchaseOrdersSearchResults.length === 0
      )
    },
    filteredHomePageResults() {

      let filteredHomePageResults = []

      let cardResults = this.getHomePageCardsResults()
      let uniqueCardResults = this.getUniqueListBy(cardResults, 'id')


      let decisionBranchesResults = this.getHomePageDecisionBranchesResults()
      let uniqueDecisionBranchesResults = this.getUniqueListBy(decisionBranchesResults, 'id')


      let sectionsResults = this.getHomePageSectionsResults()
      let uniqueSectionsResults = this.getUniqueListBy(sectionsResults, 'id')

      filteredHomePageResults = uniqueCardResults.concat(uniqueDecisionBranchesResults, uniqueSectionsResults)

      return filteredHomePageResults
    },
    filteredProducts() {
      const filteredProducts = this.products.filter(({ name }) => _includes(name.toLowerCase(), this.searchTerm.toLowerCase()));
      return this.getFilteredProducts(filteredProducts);
    },
    filteredSuppliers() {
      return this.suppliers.filter(({ name, supplierId }) =>
        _includes(name.toLowerCase(), this.searchTerm.toLowerCase()) || _includes(supplierId.toLowerCase(), this.searchTerm.toLowerCase())
      );
    },
    filteredPendingCases() {
      return this.onBoardingPendingRequests.filter(({ caseNumber }) => _includes(caseNumber.toLowerCase(), this.searchTerm.toLowerCase()));
    },
    filteredCompletedCases() {
      return this.onBoardingCompletedRequests.filter(({ caseNumber }) => _includes(caseNumber.toLowerCase(), this.searchTerm.toLowerCase()));
    },
    filteredReturnedCases() {
      return this.onBoardingReturnedRequests.filter(({ caseNumber }) => _includes(caseNumber.toLowerCase(), this.searchTerm.toLowerCase()));
    },
    filteredInvoiceSearchResults() {
      return this.filterKeyValueFromObject(this.formattedInvoices, true)
    },
    filteredPurchaseOrdersSearchResults() {
      return this.filterKeyValueFromObject(this.purchaseOrdersFormattedList, false)
    }
  },
  methods: {
    ...mapMutations(["setSearchResult","setBreadcrumbItems","setShowSearchSpinner"]),
    ...mapActions(["fetchAllSuppliers","fetchAllProducts","fetchAllOnBoardingRequests", "fetchInvoicesAndPurchaseOrders","getAppData"]),
    launchAgentStatusModal(caseNumber) {
      this.$emit("clearSearchTerm");
      this.$router.push({name: "RITMStatus", params: {ritm: caseNumber}})
    },
    trackHomePageSearchResultClicked(title, url) {
      let event = 'Supplier central - Homepage search result clicked'
      let subEvent = `${title} - ${url}`
      this.trackEvent(event, subEvent)
    },
    updateUrl(url) {
      return filters.updateUrlWithHttp(url)
    },
    onSearchResultClicked() {
      this.$emit("clearSearchTerm");
    },
    getHomePageSectionsResults() {
      let homePageSectionsResults = []

      const currentUrl = window.location.href;

      let baseUrl = currentUrl.includes(CONSTANTS.LOCALHOST_URL) ? 'http://'+CONSTANTS.LOCALHOST_URL : CONSTANTS.EH_URL
      let jumpLinkURL = baseUrl + CONSTANTS.JUMP_LINKS_URL

      this.decisionBranches.sections.forEach((section) => {
        if(section.name.toLowerCase().includes(this.searchTerm.toLowerCase()))
          homePageSectionsResults.push({ id: section.id, route: jumpLinkURL+section.jumpLink, name: section.name, actionType: 'LINK'  })

        if(section.subSection1Resources && section.subSection1Resources.length > 0) {
          section.subSection1Resources.forEach((resource, index) => {
            if(resource.title.toLowerCase().includes(this.searchTerm.toLowerCase())) {
              homePageSectionsResults.push({ id: index, route: resource.value, name: resource.title, actionType: 'LINK'  })
            }
          })
        }
        if(section.subSection2Resources && section.subSection2Resources.length > 0) {
          section.subSection2Resources.forEach((resource, index) => {
            if(resource.title.toLowerCase().includes(this.searchTerm.toLowerCase()))
            {
              homePageSectionsResults.push({ id: index, route: resource.value, name: resource.title, actionType: 'LINK'  })
            }
          })
        }
        if(section.subSection3Resources && section.subSection3Resources.length > 0) {
          section.subSection3Resources.forEach((resource, index) => {
            if(resource.title.toLowerCase().includes(this.searchTerm.toLowerCase())) {
              homePageSectionsResults.push({ id: index, route: resource.value, name: resource.title, actionType: 'LINK'  })
            }
          })
        }
      })
      return homePageSectionsResults
    },
    getHomePageDecisionBranchesResults() {
      let decisionBranchesResults = []
      this.decisionBranches.cardDecisionBranches.forEach((decisionBranch) => {
        if((decisionBranch.actionType ==='MODAL' && decisionBranch.name.toLowerCase().includes(this.searchTerm.toLowerCase())))
          decisionBranchesResults.push({ name: decisionBranch.name, actionType: decisionBranch.actionType, route: decisionBranch.id, id: decisionBranch.id })
        else if(decisionBranch.actionType === 'LINK' && decisionBranch.name.toLowerCase().includes(this.searchTerm.toLowerCase()))
          decisionBranchesResults.push({ name: decisionBranch.name, actionType: decisionBranch.actionType, route: decisionBranch.actionLink, id: decisionBranch.id })
      })
      return decisionBranchesResults
    },
    getHomePageCardsResults() {
      let cardResults = []
      this.decisionBranches.cards.forEach((card) => {
        if(card.actionType ==='MODAL' && card.name.toLowerCase().includes(this.searchTerm.toLowerCase()))
          cardResults.push({ name: card.name, actionType: card.actionType, route: card.id, id: card.id })
        else if(card.actionType === 'LINK' && card.name.toLowerCase().includes(this.searchTerm.toLowerCase()))
          cardResults.push({ name: card.name, actionType: card.actionType, route: card.actionLink, id: card.id })
      })
      return cardResults
    },
    async updateSearchSources() {

      let appDataIsFetched = ''
      let allSuppliersFetched = ''
      let allProductsFetched = ''
      let allOnboardingRequestsFetched = ''
      let esResultsFetched = ''
      let invoicePODataFetched = ''
      let homePageResultsFetched = ''


      if(!this.currentAppData) {
        appDataIsFetched = await this.getAppData(CONSTANTS.GUIDES_ALIAS)
      }

      //We need to enable this when Supplier Results are to be displayed back again.
      // if(this.suppliers.length === 0)
      //   allSuppliersFetched = this.fetchAllSuppliers();

      if(this.products.length === 0)
        allProductsFetched = this.fetchAllProducts();

      if(this.formattedInvoices.length === 0 || this.purchaseOrdersFormattedList.length === 0){
        invoicePODataFetched = this.fetchInvoicesAndPurchaseOrders()
        await this.getAllNamesForFilter()
        this.resetPoTableUserPreferences()
        this.poFiltersList.isFiltersReloaded = false
        this.resetInvoiceTableUserPreferences()
      }


      if(this.onBoardingPendingRequests.length === 0
          && this.onBoardingCompletedRequests.length === 0
          && this.onBoardingReturnedRequests.length === 0)
        allOnboardingRequestsFetched = this.fetchAllOnBoardingRequests();

      if(this.currentAppData && this.currentAppData.enableEnterpriseSearch && this.currentAppData.enterpriseSearchQuery) {
        esResultsFetched = this.getEnterpriseSearchResults()
      }

      if(this.decisionBranches.length === 0) {
        homePageResultsFetched = this.fetchDecisionBranches()
      }

      await Promise.all([appDataIsFetched,
        allSuppliersFetched,
        allProductsFetched,
        allOnboardingRequestsFetched,
        esResultsFetched,
        invoicePODataFetched,
        homePageResultsFetched])

      this.setShowSearchSpinner(false);
    },
    redirectToSolutionsModal(searchResult) {
      if(searchResult.linkName){
        if(this.currentAppData.enterpriseSearchQuery){
          this.$hhMixpanel.trackEvent("Page Hit: Supplier Central Enterprise Search - Search Result Selected", {
            subEvent: "query="+this.searchTerm,
            eventUrl: searchResult.linkValue
          });
        }
        window.open(searchResult.linkValue, '_blank')
      }else {
        this.navigateToRecord(searchResult.id)
      }
    },
    navigateToRecord(id) {
      this.setBreadcrumbItems([])
      let resultUrl = "";
      resultUrl = `/${this.currentAlias}/${id}`;
      this.onSearchResultClicked();
      if (id !== this.$route.params.id)
        this.$router.push(resultUrl);
    },
    getSolutionParent(parentArray, searchResult) {
      let parentSolution = parentArray.filter(
        (parent) => parent.id === searchResult.parentCategoryId
      );
      return parentSolution;
    },
    engageWithSupplier(vendorId) {
      let subEvent = `vendorId: `+vendorId
      this.trackEvent("Engage with Supplier initiated",subEvent)
      this.$router.replace({ name: "OneIntakeForm", query: {vendorId: vendorId} });
      this.onSearchResultClicked()
    },
    navigateTo(branchId) {
      this.$router.replace({name: 'branches', params: { id : branchId}})
      this.trackHomePageSearchResultClicked('BRANCH', branchId)
      this.onSearchResultClicked()
    },
    editReturnedRequest(id) {
      this.trackEvent("Edit returned request case consumed")
      this.$router.push({name: "ReturnedRequestIntakeForm", params: { id } })
      this.onSearchResultClicked()
    },
    trackEvent(event, subEvent) {
      this.$hhMixpanel.trackEvent(event, {subEvent})
    },
    searchCategoryForSubstring(currentObj, key) {
      /* validate if current object[key] which has a stringValue has a searchTerm match */
      if(currentObj[key]) {
        if(currentObj[key].toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1) {
          return currentObj
        }
      }
    },
    searchCategoryForSubStringInArray(currentObj, key) {
      /* validate if current object[key] which has a arrayValue has a searchTerm match */
      if(currentObj[key] && currentObj[key].length > 0) {
        if(currentObj[key].findIndex(element => element.toLowerCase().includes(this.searchTerm.toLowerCase())) !== -1) {
          return currentObj
        }
      }
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()]
    },
    searchDebounce: debounce(
        that => {
          that.updateSearchSources();
        },
        1000,
        { leading: false }
    ),
    async getEnterpriseSearchResults(){
      this.showErrorMessage = false;

      try {
        const response = await api.getSearchResults(this.searchTerm,this.currentAppData.enterpriseSearchQuery,this.currentAppData.enterpriseSearchResultsLength);
        
        this.searchResults = response.data.data.search.hits.map(({ title, content, url, type }) => ({
          name: title,
          description: content,
          linkName: title,
          linkValue: url,
          type
        }))
        if(!response.data.data.search.hits || response.data.data.search.hits.length===0){
            this.trackEvent("Page Hit: Supplier Central Enterprise Search - No Result Search", "query="+this.searchTerm);
        }
      } catch (error) {
        this.setErrorMessage(CONSTANTS.ERROR_MESSAGE);
        this.showErrorMessage = true; 
      }

      this.trackEvent("Page Hit: Supplier Central Enterprise Search","query="+this.searchTerm)
    },
    // Below method searches for value in every key for an Invoice array of Obj or PO array of Obj based on where its called from.
    // This way we ensure invoices and POs are searched for all values in set keys.
    // When we return, we also return whether or not its invoice or PO for correct routing.
    filterKeyValueFromObject(array) {
      let searchResult = []
      array.forEach(item => {
        for(var prop in item) {
          if(item.hasOwnProperty(prop)) {
            if(item[prop].toString().toLowerCase().includes(this.searchTerm.toLowerCase())) {
              searchResult.push ({ key: prop, value: item})
            }
          }
        }
      })
      return searchResult
    }
  },
};
</script>

<style scoped>

.solution-link-title {
  color: var(--secondary-color) !important;
  font-weight: bold;
  cursor: pointer;
  font-size: 20px;
}
.search-results-container {
  min-height: 500px;
}

.edit-case-link {
  cursor: pointer;
  color: var(--secondary-color);
  font-size: 16px;
}

.large-panel{
  margin:15px;
}
.no-match-card {
  background-color: #f4f8fa;
  color: #979797;
  padding: 45px;
}
.search-result-title {
  color: var(--secondary-color);
  font-family: artifaktElementBold;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
}


.search-results-panel {
  background-color: #fff;
  color: #979797;
  font-size: 14px;
  margin-bottom: 10px !important;
  margin-top: 0px !important;
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding: 15px !important;
  min-height: 80px;
  border: 1px solid #64788D;
  border-radius: 3px;
}
.search-results-panel a:hover{
  color:#0056b3;
  text-decoration: none;
}
.search-result-desc{
  color:#000;
  font-size: 16px;
}

.view-status {
  color: var(--secondary-color);
  cursor: pointer;
  font-size: 16px;
}
</style>